"use client";

import Script from "next/script";
import { PUBLIC_ENV_VARS } from "@/utils/common/environment";
import { GTM_NOSCRIPT_SANDBOX } from "@/utils/common/iframeSandbox";

function getGtmId(): string | undefined {
  const id = PUBLIC_ENV_VARS.GTM_ID?.trim();
  return id || undefined;
}

function serializeInlineScriptValue(value: string): string {
  return JSON.stringify(value).replaceAll("<", String.raw`\u003C`);
}

export function GoogleTagManagerHead() {
  const gtmId = getGtmId();
  if (!gtmId) {
    return null;
  }

  const serializedGtmId = serializeInlineScriptValue(gtmId);
  const gtmBootstrap = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer',${serializedGtmId});`;

  return (
    <Script
      id="google-tag-manager"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: gtmBootstrap }}
    />
  );
}

export function GoogleTagManagerNoScript() {
  const gtmId = getGtmId();
  if (!gtmId) {
    return null;
  }

  const encodedGtmId = encodeURIComponent(gtmId);

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${encodedGtmId}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="Google Tag Manager"
        sandbox={GTM_NOSCRIPT_SANDBOX}
        referrerPolicy="no-referrer"
      />
    </noscript>
  );
}
